<template>
  <b-row>
    <b-col
      cols="12"
      class="d-flex align-items-center justify-content-between mb-1"
    >
      <div class="d-flex align-items-center" style="gap: 8px">
        <b-button variant="outline-secondary" @click="redirectToViewRace">
          <feather-icon icon="ArrowLeftIcon" />
          Back to Race Detail
        </b-button>
        <h4 class="mb-0" v-if="form">Edit Race: {{ form.eventName }}</h4>
      </div>
    </b-col>
    <b-col cols="12" md="6">
      <b-card bg-variant="light">
        <!-- SECTION: Event Details -->
        <div class="d-flex align-items-center justify-content-between">
          <h5 class="font-weight-bold mb-1">Event Details</h5>
          <b-button variant="success" @click="submitRace">
            <feather-icon icon="SaveIcon" />
            Save Changes
          </b-button>
        </div>
        <b-form-group label="Event Key">
          <b-form-input v-model="form.eventKey" disabled></b-form-input>
        </b-form-group>

        <b-form-group label="Event Name">
          <b-form-input v-model="form.eventName"></b-form-input>
        </b-form-group>

        <b-form-group label="Start Time">
          <flat-pickr
            id="startDate"
            v-model="form.utcTime"
            class="form-control"
            :config="configDate"
            placeholder="mm/dd/yyyy"
          />
        </b-form-group>

        <b-form-group label="Venue">
          <b-form-input v-model="form.venueName"></b-form-input>
        </b-form-group>

        <b-form-group label="Number">
          <b-form-input v-model="form.eventNo"></b-form-input>
        </b-form-group>

        <b-form-group label="Event Alert Message">
          <b-form-textarea
            v-model="form.raceComment"
            rows="2"
          ></b-form-textarea>
        </b-form-group>

        <!-- SECTION: Promos -->
        <h5 class="font-weight-bold">Promos</h5>

        <b-form-group>
          <b-form-checkbox
            v-model="form.promotionDisabled"
            switch
            @click.native.prevent="handleOpenChange"
          >
            Open
          </b-form-checkbox>
        </b-form-group>
      </b-card>
    </b-col>
    <b-col cols="12" md="6">
      <b-card>
        <Markets />
      </b-card>
    </b-col>
    <b-col cols="12">
      <b-card>
        <Competitors ref="competitors" @save-runners="handleSaveRunners" />
      </b-card>
    </b-col>
    <DisabledRaceModal @onAfterConfirm="handleDisableConfirmed" />

    <b-modal
      id="status-crawl-modal"
      title="Update Status Crawl"
      centered
      cancel-variant="outline-secondary"
    >
      <b-card-text style="color: black"
        >Are you sure you want to disable crawl status
      </b-card-text>
      <!-- FOOTER -->
      <template #modal-footer>
        <div class="d-flex justify-content-end mt-1">
          <b-button variant="secondary" class="mr-1" @click="handleCloseModal">
            Cancel
          </b-button>
          <b-button
            variant="primary"
            @click="handleSubmit"
            :disabled="loadingUpdateConfig"
          >
            Submit
          </b-button>
        </div>
      </template>
    </b-modal>
  </b-row>
</template>

<script>
import {
  BCard,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BFormCheckbox,
  BButton,
  BRow,
  BCol,
  BModal,
  BCardText,
} from "bootstrap-vue";
import flatPickr from "vue-flatpickr-component";
import Markets from "./Markets.vue";
import Competitors from "./Competitors.vue";
import { mapState, mapActions } from "vuex";
import useToastHandler from "@/services/toastHandler";
import DisabledRaceModal from "../view/modals/DisabledRaceModal.vue";

export default {
  components: {
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BFormCheckbox,
    BButton,
    BRow,
    BCol,
    BCard,
    flatPickr,
    Markets,
    Competitors,
    DisabledRaceModal,
    BModal,
    BCardText,
  },

  data() {
    return {
      form: {
        eventKey: "",
        eventName: "",
        utcTime: "",
        venueName: "",
        eventNo: "",
        eventAlertMessage: "",
        promotionDisabled: false,
        isDisableSync: false,
      },
      pendingAction: null,
      pendingRunners: null,
      configDate: {
        enableTime: true,
        dateFormat: "Y-m-d H:i:S",
        enableSeconds: true,
      },
    };
  },
  computed: {
    ...mapState("trading/racing", ["dataRaceDetail", "loadingUpdateConfig"]),
  },
  watch: {
    dataRaceDetail(newVal) {
      this.form.promotionDisabled = newVal.promotionDisabled || false;
    },
  },
  created() {
    this.fetchRace();
    this.getDetailOfRace(this.$route.query.raceId);
  },
  methods: {
    ...mapActions("trading/racing", [
      "getRacesOfMeeting",
      "updateRaceDetail",
      "updateRunnersOfRace",
      "getDetailOfRace",
      "updateRaceConfigMarket",
    ]),
    async fetchRace() {
      const type = this.$route.query.type;
      const data = await this.getRacesOfMeeting({
        meetingId: this.$route.params.id,
        raceId: this.$route.query.raceId,
        ...(type && { type }),
      });
      const race = data?.[0] || {};
      this.form = {
        eventKey: race.raceId,
        eventName: race.eventName,
        utcTime: race.utcTime,
        venueName: race.venueName,
        eventNo: race.eventNo,
        eventAlertMessage: race.eventAlertMessage,
        isDisableSync: race.isDisableSync,
      };
    },
    submitRace() {
      if (!this.form.isDisableSync) {
        this.pendingAction = "SAVE_RACE";
        this.$bvModal.show("disabled-race-modal");
        return;
      }
      this.updateRace();
    },
    async updateRace() {
      try {
        await this.updateRaceDetail({
          raceId: this.$route.query.raceId,
          eventName: this.form.eventName,
          utcTime: this.form.utcTime,
          venueName: this.form.venueName,
          eventNo: Number(this.form.eventNo),
          raceComment: this.form.raceComment,
          isDisableSync: this.form.isDisableSync,
        });
        this.showToastSuccess("Race updated successfully");
      } catch {
        this.showToastError("Failed to update race");
      }
    },
    handleSaveRunners(runners, { onlyScratchedChanged } = {}) {
      if (!this.form.isDisableSync && !onlyScratchedChanged) {
        this.pendingAction = "SAVE_RUNNERS";
        this.pendingRunners = runners;
        this.$bvModal.show("disabled-race-modal");
        return;
      }
      this.updateRunners(runners);
    },
    async updateRunners(runners) {
      try {
        const res = await this.updateRunnersOfRace({
          raceId: this.$route.query.raceId,
          runners,
        });
        if (res === undefined) return;
        this.$refs.competitors.markSaved();
        this.showToastSuccess("Runners updated successfully");
      } catch {
        this.showToastError("Failed to update runners");
      }
    },
    async handleDisableConfirmed() {
      this.form.isDisableSync = true;
      if (this.pendingAction === "SAVE_RACE") {
        this.pendingAction = null;
        await this.updateRace();
      }
      if (this.pendingAction === "SAVE_RUNNERS") {
        const runners = this.pendingRunners;
        this.pendingAction = null;
        this.pendingRunners = null;
        await this.updateRunners(runners);
      }
    },
    redirectToViewRace() {
      const query = { raceId: this.$route.query.raceId };
      if (this.$route.query.type) query.type = this.$route.query.type;
      this.$router.push({
        name: "trading-racing-view",
        params: { id: this.$route.params.id },
        query,
      });
    },
    async handleSubmit() {
      const raceId = this.$route.query.raceId;
      const result = await this.updateRaceConfigMarket({
        raceId,
        promotionDisabled: !this.form.promotionDisabled,
      });
      if (result) {
        this.showToastSuccess("success", "Updated status successfully!");
        this.form.promotionDisabled = !this.form.promotionDisabled;
        this.handleCloseModal();
      }
    },
    handleOpenChange() {
      this.$bvModal.show("status-crawl-modal");
    },
    handleCloseModal() {
      this.$bvModal.hide("status-crawl-modal");
    },
  },
  setup() {
    const { showToastError, showToastSuccess } = useToastHandler();
    return {
      showToastError,
      showToastSuccess,
    };
  },
};
</script>